import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, input, output } from '@angular/core';
import { CDN_URL } from '@maximizer/core/shared/domain';
import {
  AppointmentService,
  OutlookStore,
} from '@maximizer/outlook/shared/data-access';
import { AppointmentSummary } from '@maximizer/outlook/shared/domain';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize } from 'rxjs';

@Component({
  selector: 'maximizer-summary-appointment',
  templateUrl: './summary-appointment.component.html',
  imports: [DatePipe, OUTLOOK_SHARED_UI, TranslatePipe],
})
export class SummaryAppointmentComponent implements OnInit {
  deepLink = input<string>();
  type = input<string>();
  id = input('');

  loadErrorEvent = output<string>();
  loadingEvent = output<boolean>();

  configuration: AppointmentSummary = { appointmentAmount: 0 };
  abEntryKey: string | null = null;
  leadKey: string | null = null;
  loading = true;
  attendees: string[] = [];

  constructor(
    @Inject(CDN_URL) public cdn: string,
    private readonly appointmentService: AppointmentService,
    public outlookStore: OutlookStore,
  ) {}

  ngOnInit(): void {
    const type = this.type();
    const id = this.id();
    if (type === 'lead') this.leadKey = decodeURI(id);
    if (type === 'abentry') this.abEntryKey = decodeURI(id);
    this.loadData();
  }

  private loadData(): void {
    const key = this.leadKey ?? this.abEntryKey;
    if (!key || key == '') return;

    this.appointmentService
      .getSummary(key, this.type() ?? '')
      .pipe(
        catchError(async () => this.loadErrorEvent.emit('appointment')),
        finalize(() => {
          this.loadingEvent.emit(false);
          this.loading = false;
        }),
      )

      .subscribe((data) => {
        if (!data) return;

        if (data.appointmentAmount > 0) {
          data.appointmentAmount = data.appointmentAmount - 1;
        }

        this.configuration = data;
        this.createAttendees();
      });
  }

  private createAttendees(): void {
    const userNames = this.configuration.appointment?.users ?? [];

    const abEntries =
      this.configuration.appointment?.abEntries?.map((abEntry) => {
        if (abEntry.type === 'Company') {
          return abEntry.companyName;
        } else {
          return `${abEntry.firstName} ${abEntry.lastName}`.trim();
        }
      }) ?? [];

    const leadNames =
      this.configuration.appointment?.leads?.map((lead) =>
        `${lead.firstName} ${lead.lastName}`.trim(),
      ) ?? [];

    this.attendees = [...userNames, ...leadNames, ...abEntries];
  }
}
